var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar-body" },
            [
              _vm._l(_vm.inputSearchForms, function(form, i) {
                return form.division === "C"
                  ? _c("ul", { staticClass: "sidebar-nav" }, [
                      i === 0
                        ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                            _vm._v(" ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "d-block has-text-weight-semibold",
                            attrs: { for: form.id }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "mg-b-0 text-left" }, [
                          _vm._v(_vm._s(_vm.platingData[form.id]))
                        ])
                      ])
                    ])
                  : form.division === "O"
                  ? _c("ul", { staticClass: "sidebar-nav" }, [
                      i === 0
                        ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                            _vm._v(" ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "d-block has-text-weight-semibold",
                            attrs: { for: "formGroupExampleInput" }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        form.value.length > 0
                          ? _c(
                              "p",
                              { staticClass: "mg-b-0 text-left" },
                              _vm._l(form.value, function(form1, i) {
                                return form1.codeCode ==
                                  _vm.platingData[form.id]
                                  ? _c("span", [_vm._v(_vm._s(form1.codeName))])
                                  : _vm._e()
                              }),
                              0
                            )
                          : _c("p", { staticClass: "mg-b-0 text-left" }, [
                              _vm._v(_vm._s(_vm.platingData[form.id]))
                            ])
                      ])
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.checkboxSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: " d-block has-text-weight-semibold",
                          attrs: { for: "formGroupExampleInput" }
                        },
                        [_vm._v(_vm._s(form.name))]
                      ),
                      _vm._v(" "),
                      _vm._l(form.value, function(form1, j) {
                        return _vm.platingData[form.id] == form1.codeCode
                          ? _c("p", { staticClass: "mg-b-0 text-left" }, [
                              _vm._v(_vm._s(form1.codeName))
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.dateSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "d-block has-text-weight-semibold",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mg-b-0 text-left" }, [
                      _vm._v(_vm._s(_vm.platingData[form.id]))
                    ])
                  ])
                ])
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components overflow-hidden" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v("View")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName) + " View")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      attrs: {
                        to: {
                          name: this.$route.name.replace("_completion", ""),
                          params: { mid: this.properties.mid, type: "list" }
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass:
                          "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                        attrs: { type: "file" }
                      }),
                      _vm._v("list")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                      attrs: {
                        href: "#modal1",
                        "data-toggle": "modal",
                        "data-animation": "effect-flip-horizontal"
                      },
                      on: { click: function($event) {} }
                    },
                    [
                      _c("feather", {
                        staticClass:
                          "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                        attrs: { type: "file" }
                      }),
                      _vm._v("SAMPLESHEET")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: " pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
            _c("div", { staticClass: "col-sm-6 col-lg-5 d-inline-block" }, [
              _c(
                "ul",
                {
                  staticClass: "cardborder nav nav-tabs",
                  attrs: { id: "myTab", role: "tablist" }
                },
                [
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link active",
                        attrs: {
                          id: "plating-tab",
                          "data-toggle": "tab",
                          href: "#plating",
                          role: "tab",
                          "aria-controls": "plating",
                          "aria-selected": "true"
                        },
                        on: { click: function($event) {} }
                      },
                      [_vm._v("Plating")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(1)
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card card-body" }, [
              _c(
                "div",
                {
                  staticClass: "tab-content mg-t-20",
                  attrs: { id: "myTabContent" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade lm-overflow show active",
                      attrs: {
                        id: "plating",
                        role: "tabpanel",
                        "aria-labelledby": "plating-tab"
                      }
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-line",
                          attrs: { id: "myTab5", role: "tablist" }
                        },
                        _vm._l(_vm.tabHeader, function(form, i) {
                          return _vm.properties.mid === form.id
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "home",
                                      "aria-selected": "true"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.classifySampleHeader(
                                          form.id,
                                          _vm.tabHeader.length,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                            : _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "profile",
                                      "aria-selected": "false"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.classifySampleHeader(
                                          form.id,
                                          _vm.tabHeader.length,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-none d-md-block tx-right-f" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                  attrs: {
                                    href: "#modal2",
                                    "data-toggle": "modal",
                                    "data-animation": "effect-flip-horizontal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getGroup()
                                    }
                                  }
                                },
                                [
                                  _c("feather", {
                                    staticClass:
                                      "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                    attrs: { type: "minus" }
                                  }),
                                  _vm._v("re-plating")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f",
                                  attrs: {
                                    href: "",
                                    "data-toggle": "modal",
                                    "data-animation": "effect-flip-horizontal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.excelExport()
                                    }
                                  }
                                },
                                [
                                  _c("feather", {
                                    staticClass:
                                      "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                    attrs: { type: "file-text" }
                                  }),
                                  _vm._v("Excel")
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "section",
                            [
                              _c(
                                "b-table",
                                {
                                  ref: "table",
                                  staticClass:
                                    "overflow-x-hidden b-table-fix-header",
                                  attrs: {
                                    id: "btable",
                                    data: _vm.isEmpty ? [] : _vm.sampleData,
                                    "checked-rows": _vm.checkedRows,
                                    checkable: "",
                                    hoverable: "",
                                    striped: ""
                                  },
                                  on: {
                                    "update:checkedRows": function($event) {
                                      _vm.checkedRows = $event
                                    },
                                    "update:checked-rows": function($event) {
                                      _vm.checkedRows = $event
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(props) {
                                        return _vm._l(
                                          _vm.sampleHeader,
                                          function(form, i) {
                                            return i == 0
                                              ? _c(
                                                  "b-table-column",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      field: "No",
                                                      label: "No"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(props.row.no))]
                                                )
                                              : Number(i) == 1
                                              ? _c(
                                                  "b-table-column",
                                                  {
                                                    key: form.id,
                                                    attrs: {
                                                      "custom-key": form.id,
                                                      field: form.columnCode,
                                                      label: form.columnName,
                                                      centered: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: "#modal5",
                                                          id: props.index,
                                                          "data-toggle":
                                                            "modal",
                                                          "data-animation":
                                                            "effect-flip-horizontal"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.sendId(
                                                              props.row.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row[
                                                                form.columnCode
                                                              ]
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "b-table-column",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      field: form.columnCode,
                                                      label: form.columnName,
                                                      centered: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.row[
                                                          form.columnCode
                                                        ]
                                                      )
                                                    )
                                                  ]
                                                )
                                          }
                                        )
                                      }
                                    }
                                  ])
                                },
                                [
                                  _vm._v(" "),
                                  _c("template", { slot: "empty" }, [
                                    _c("section", { staticClass: "section" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "content has-text-grey has-text-centered"
                                        },
                                        [_c("p", [_vm._v("Nothing here.")])]
                                      )
                                    ])
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade",
                      attrs: {
                        id: "plate",
                        role: "tabpanel",
                        "aria-labelledby": "plate-tab"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-6 col-lg-6 mg-t-10 mg-sm-t-0" },
                        [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  Number(_vm.well_column) * Number(_vm.well_row)
                                ) + " Well Plate"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group row row-nowrap" },
                            [
                              _c("number-input", {
                                attrs: {
                                  type: "text",
                                  min: 1,
                                  max: 12,
                                  size: "small",
                                  center: ""
                                },
                                model: {
                                  value: _vm.well_column,
                                  callback: function($$v) {
                                    _vm.well_column = _vm._n($$v)
                                  },
                                  expression: "well_column"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-sm-2" }, [
                                _vm._v("X")
                              ]),
                              _vm._v(" "),
                              _c("number-input", {
                                attrs: {
                                  type: "text",
                                  min: 1,
                                  max: 8,
                                  size: "small",
                                  center: ""
                                },
                                model: {
                                  value: _vm.well_row,
                                  callback: function($$v) {
                                    _vm.well_row = _vm._n($$v)
                                  },
                                  expression: "well_row"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { id: "custom-view" } },
                            [
                              _c(
                                "ul",
                                { staticClass: "board" },
                                [
                                  _c("li", { staticClass: "fl tc w1 list2" }),
                                  _vm._v(" "),
                                  _vm._l(_vm.well_column, function(column) {
                                    return _c(
                                      "li",
                                      { staticClass: "fl tc w1 list2" },
                                      [_vm._v(_vm._s(Number(column)))]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.well_row, function(row) {
                                return _c("ul", { staticClass: "board" }, [
                                  _c(
                                    "li",
                                    { staticClass: "fl tc w2 list2 pt-sm-2" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.well_row_a[Number(row) - 1])
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { attrs: { id: "list" + row } },
                                    _vm._l(_vm.well_column, function(column) {
                                      return _c(
                                        "li",
                                        {
                                          staticClass: "fl tc w2 list1 pt-sm-2",
                                          attrs: {
                                            id:
                                              _vm.well_row_a[Number(row) - 1] +
                                              column
                                          }
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.well_row_a[Number(row) - 1]
                                              ) + _vm._s(Number(column))
                                            )
                                          ])
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal5",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel5",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          staticStyle: { "background-color": "rgba(0, 0, 0, 0.4)" },
          attrs: {
            id: "modal1",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "limitModal",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              staticStyle: { "max-width": "570px" },
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row row-xs mt-1 d-block" }, [
                    _c(
                      "div",
                      { staticClass: "list-group" },
                      [
                        _c("h6", { staticClass: "is-pulled-left" }, [
                          _vm._v("• Version")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-field",
                          { attrs: { type: _vm.chkType, message: _vm.chkMsg } },
                          [
                            _c(
                              "b-select",
                              {
                                attrs: {
                                  placeholder: "Select a character",
                                  expanded: "",
                                  loading: _vm.selectLoading
                                },
                                model: {
                                  value: _vm.selectedOptions,
                                  callback: function($$v) {
                                    _vm.selectedOptions = $$v
                                  },
                                  expression: "selectedOptions"
                                }
                              },
                              [
                                _c("option", { attrs: { value: "Original" } }, [
                                  _vm._v("Original")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "LRM" } }, [
                                  _vm._v("LRM")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary tx-13",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.csvExport(_vm.selectedOptions)
                        }
                      }
                    },
                    [_vm._v("EXPORT")]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          staticStyle: { "background-color": "rgba(0, 0, 0, 0.4)" },
          attrs: {
            id: "modal2",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "limitModal",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              staticStyle: { "max-width": "570px" },
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row row-xs mt-1 d-block" }, [
                    _c(
                      "div",
                      { staticClass: "list-group" },
                      [
                        _c("h6", { staticClass: "is-pulled-left" }, [
                          _vm._v("• Group")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-field",
                          { attrs: { type: _vm.chkType, message: _vm.chkMsg } },
                          [
                            _c(
                              "b-select",
                              {
                                attrs: {
                                  placeholder: "Select a character",
                                  expanded: ""
                                },
                                model: {
                                  value: _vm.selectedGroup,
                                  callback: function($$v) {
                                    _vm.selectedGroup = $$v
                                  },
                                  expression: "selectedGroup"
                                }
                              },
                              _vm._l(_vm.editableGroup, function(option) {
                                return _c(
                                  "option",
                                  {
                                    key: option.id,
                                    domProps: { value: option.id }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(option.platingNo) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary tx-13",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.rePlating(_vm.selectedGroup)
                        }
                      }
                    },
                    [_vm._v("Create")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-header" }, [
      _c("h5", [_vm._v("Search")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "", id: "sidebarMenuClose" } }, [
        _c("i", { attrs: { "data-feather": "x" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: {
            id: "plate-tab",
            "data-toggle": "tab",
            href: "#plate",
            role: "tab",
            "aria-controls": "plate",
            "aria-selected": "false"
          }
        },
        [_vm._v("Plate")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h6", { staticClass: "modal-title", attrs: { id: "limitModal" } }, [
        _vm._v("DOWNLOAD")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h6", { staticClass: "modal-title", attrs: { id: "limitModal" } }, [
        _vm._v("Re-Plating")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e2d8c3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e2d8c3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Sequencing/Plating/CompletionForm.vue
// module id = null
// module chunks = 